import React, { useEffect, useRef, useState } from "react";
import Pagination from "react-js-pagination";
import ConfigDB from "../../config";
import { toast } from "react-toastify";
import Utils from "../../utils";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import * as XLSX from "xlsx";
import { useLocation, useNavigate } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";

import Select from "react-select";

import { useTranslation } from "react-i18next";
import {
  createInpvoiceInternalSales,
  getCompanySalesList,
  internalSalesFileUpdate,
  updateCompanySalesStatus,
  deleteInvoiceFileInternalSales,
  getCheckMCustomer,
  getEcommerceSalesDetailsList,
} from "../../services/SalesServices";
import { getCommonSearchList } from "../../services/settingsServices";
import { getCompanyEcommerceHashList } from "../../services/CompanyEcommerceHashService";
import moment from "moment";
import ReactPaginate from "react-paginate";
import {
  getDocumentSetList,
  getListCustomerList,
} from "../../services/MoloniServices";
import { tConstStatic } from "../../utils/constantsTranslator";

const Sales = () => {
  const location = useLocation();
  const { state } = location;

  const tableLengthList = ConfigDB.data.dataTableLength;
  const data = localStorage.getItem(ConfigDB.data.login_data);
  const companyId = JSON.parse(data);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const fileInputRef = useRef(null);

  const [params, setParams] = useState({
    limit: tableLengthList[0],
    page: 1,
    search: "",
    is_reload: false,
    company_id: companyId.company_id || 0,
    order_status: 0,
    market_place_id: 0,
  });

  const [totalRecords, setTotalRecords] = useState(0);

  const [salesList, setSalesList] = useState([]);
  const [statusModal, setStatusModal] = useState(false);
  const [delModal, setDelModal] = useState(false);
  const [isDelButtonLoad, setIsDelButtonLoad] = useState(false);
  const [statusChange, setStatusChange] = useState("");
  const [modifyModal, setModifyModal] = useState(false);
  const [salesViewData, setSalesViewData] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [orderStatusNameList, setOrderStatusNameList] = useState([]);
  const [companyEcommerceList, setCompanyEcommerceList] = useState([]);
  const [salesData, setSalesData] = useState({
    order_status: "",
  });
  const [selectedRadio, setSelectedRadio] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);

  let errorsObj = {
    shipping_company: "",
    shipping_tracking_code: "",
    reason_failed_sale: "",
    add_file: "",
    date: "",
    document_set_id: "",
    customer_id: "",
    expiration_date: "",
    your_reference: "",
    our_reference: "",
  };
  const [errors, setErrors] = useState(errorsObj);

  const [failedData, setFailedData] = useState({
    shipping_company: "",
    shipping_tracking_code: "",
    reason_failed_sale: "",
    add_file: "",
  });

  let errorsObjRefund = {
    refund_value: "",
    refund_type: "",
    refund_reason: "",
  };
  const [errorsRefund, setErrorsRefund] = useState(errorsObjRefund);

  const [refundData, setRefundData] = useState({
    refund_value: "",
    refund_type: "",
    refund_reason: "",
  });

  const statusColorMap = {
    1: "#f59e0b", // In-Progress
    2: "#3b82f6", // Accepted
    3: "#10b981", // Delivered
    4: "#ef4444", // Cancelled
    5: "#8b5cf6", // Refund
    6: "#f97316", // With Incidence
    7: "#22c55e", // Incidence treated
  };

  const [modifyAcceptedModal, setModifyAcceptedModal] = useState(false);
  const [modifyCancelModal, setModifyCancelModal] = useState(false);
  const [modifyRefundModal, setModifyRefundModal] = useState(false);
  const [refundTypeList, setRefundTypeList] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refundLoading, setRefundLoading] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);
  const [syncFormData, setSyncFormData] = useState({
    date: new Date().toISOString().split("T")[0],
    expiration_date: new Date().toISOString().split("T")[0],
    document_set_id: "",
    customer_id: "",
    our_reference: "",
    your_reference: "",
    notes: "",
    total_value_packaging: "",
    total_value_other_parcel: "",
    total_value_shipping: "",
    exemption_vat_products: "",
    exemption_vat_shipping: "",
    exemption_vat_packaging: "",
    selected_ids: [],
  });
  const [documentSetList, setDocumentSetList] = useState([]);
  const [customerList, seCustomerList] = useState([]);
  const [exemptionList, setExemptionList] = useState([]);
  const [modifyAcceptedInternalModal, setModifyAcceptedInternalModal] =
    useState(false);
  const [selectedRadioAccepted, setSelectedRadioAccepted] = useState(null);

  const [selectedInternalFiles, setSelectedInternalFiles] = useState([]);
  const [imagePreview, setImagePreview] = useState(null);
  const [imageId, setImageId] = useState("");

  const [statusChangeModal, setStatusChangeModal] = useState(false);
  const [checkMCustomerList, setCheckMCustomerList] = useState("");
  const [imageLoader, setImageLoader] = useState(false);
  const [customerModel, setCustomerModel] = useState(false);
  const [customerAllList, setCustomerAllList] = useState([]);

  const handleCustomerModelClose = () => {
    setCustomerModel(false);
  };

  const handleCustomerModelOpen = () => {
    setCustomerModel(true);
    let data = {
      id: statusChange?.id,
    };

    getEcommerceSalesDetailsList(data)
      .then((response) => {
        setCustomerAllList(response.data.data);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const handleFileChangeImageInternal = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setSelectedInternalFiles([file]);

    // Image preview
    if (file.type.startsWith("image/")) {
      const previewUrl = URL.createObjectURL(file);
      setImagePreview(previewUrl);
    } else {
      setImagePreview(null);
    }
  };

  const removeFile = () => {
    setSelectedInternalFiles([]);

    if (imagePreview) {
      URL.revokeObjectURL(imagePreview);
      setImagePreview(null);
    }

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }

    if (imageId) {
      setImageLoader(true);
      const data = { id: imageId, sales_type: 1 };

      deleteInvoiceFileInternalSales(data)
        .then((response) => {
          toast.success(response.data.message);
          setImageLoader(false);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
          setImageLoader(false);
        });
    }
  };

  const handleAcceptedInternalClose = () => {
    setModifyAcceptedInternalModal(false);

    setSelectedInternalFiles([]);
    setImagePreview(null);

    setFailedData({
      shipping_company: "",
      shipping_tracking_code: "",
      reason_failed_sale: "",
      add_file: "",
    });

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  useEffect(() => {
    if (statusChange?.image_list?.length > 0) {
      if (statusChange?.image_list[0]?.file_type === 1) {
        setImagePreview(statusChange?.image_list[0]?.image_url);
        setImageId(statusChange?.image_list[0]?.id);
      }
    }
  }, [statusChange]);

  const handleRadioInternalSaleChange = (event) => {
    setSelectedRadioAccepted(event.target.value);
  };

  useEffect(() => {
    if (selectedRadioAccepted === "2") {
      let data = {
        id: statusChange?.id,
        sales_type: 1,
      };

      getCheckMCustomer(data)
        .then((response) => {
          setCheckMCustomerList(response.data.data);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [selectedRadioAccepted, statusChange]);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getDocumentSetList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setDocumentSetList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListCustomerList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        seCustomerList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "exception_list",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].code,
            label: response.data[i].description,
          });
        }

        setExemptionList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    if (
      state &&
      state.order_status !== undefined &&
      state.order_status !== null
    ) {
      setParams((prev) => ({
        ...prev,
        order_status: Number(state.order_status),
      }));
    }
  }, [state]);

  const handleFileChangeImage = (event) => {
    const files = Array.from(event.target.files);
    const imageFiles = files.filter((file) => file.type.startsWith("image/"));

    if (imageFiles.length === 0) {
      return;
    }

    setSelectedFiles((prevFiles) => [...prevFiles, ...imageFiles]);
  };

  const removeImage = (index) => {
    setSelectedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const handleCancelClose = () => {
    setModifyCancelModal(false);
  };

  const handleAcceptedClose = () => {
    setModifyAcceptedModal(false);
  };

  const handleRefundClose = () => {
    setModifyRefundModal(false);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type === "application/pdf") {
      setSelectedFile(file);
    } else {
      event.target.value = null;
    }
  };

  const handleRadioChange = (event) => {
    setSelectedRadio(event.target.value);
  };

  const handleCloseModal = () => {
    setModifyModal(false);
  };

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "order_status",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setOrderStatusNameList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "order_status",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setOrderStatusNameList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = { ...params };
    getCompanyEcommerceHashList(data)
      .then((response) => {
        setCompanyEcommerceList(response.data.data);
        setTotalRecords(response.data.total);
      })
      .catch((err) => {
        toast.dismiss();
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "refund_type",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setRefundTypeList(list);
      })
      .catch((err) => {});
  }, []);

  const handleSelectChangeRefund = (selectedOption) => {
    setRefundData({
      ...refundData,
      refund_type: selectedOption ? selectedOption.value : "",
    });
  };

  const handleSelectChange = (selectedOption) => {
    setSalesData({
      ...salesData,
      order_status: selectedOption ? selectedOption.value : "",
    });
    if (selectedOption?.value === 1) {
      const formData = new FormData();
      formData.append("id", statusChange.id);
      formData.append("order_status", 1);
      updateCompanySalesStatus(formData)
        .then((response) => {
          let data = { ...params };
          featchSalesList(data);
          toast.success(response.data.message);
          setStatusModal(false);
          setIsDelButtonLoad(false);
        })
        .catch((err) => {
          setIsDelButtonLoad(false);
          toast.dismiss();
          toast.error(Utils.getErrorMessage(err));
        });
    }

    if (selectedOption?.value === 2) {
      if (statusChange?.order_status === 2) {
        navigate("/accept-invoice-sales", {
            state: {
              statusChange,
              is_sale_type: 1,
            },
          });
        return; // stop execution
      }

      const formData = new FormData();
      formData.append("id", statusChange.id);
      formData.append("order_status", 2);
      updateCompanySalesStatus(formData)
        .then((response) => {
          let data = { ...params };

          featchSalesList(data);
          toast.success(response.data.message);
          setStatusModal(false);
          setIsDelButtonLoad(false);
          // setModifyAcceptedInternalModal(true);
          navigate("/accept-invoice-sales", {
            state: {
              statusChange,
              is_sale_type: 1,
            },
          });
          setDelModal(false);
        })
        .catch((err) => {
          setIsDelButtonLoad(false);
          toast.dismiss();
          toast.error(Utils.getErrorMessage(err));
        });
    }

    if (selectedOption?.value === 3) {
      setModifyAcceptedModal(true);
      setDelModal(false);
    }

    if (selectedOption?.value === 4) {
      setModifyCancelModal(true);
      setDelModal(false);
    }

    if (selectedOption?.value === 5) {
      setModifyRefundModal(true);
      setDelModal(false);
    }

    if (selectedOption?.value === 6) {
      setModifyCancelModal(true);
      setDelModal(false);
    }

    if (selectedOption?.value === 7) {
      setModifyCancelModal(true);
      setDelModal(false);
    }
  };

  const handleAddAccpetedStatusSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    if (selectedRadio === "1") {
      const formData = new FormData();
      formData.append("id", statusChange.id);
      formData.append("order_status", 3);

      if (statusChange?.seller_takes_care_shipping === true) {
        formData.append("shipping_label", selectedFile);
        formData.append("shipping_company", failedData.shipping_company);
        formData.append(
          "shipping_tracking_code",
          failedData.shipping_tracking_code,
        );
      }

      selectedFiles.forEach((file) => {
        formData.append("order_images", file);
      });

      updateCompanySalesStatus(formData)
        .then((response) => {
          featchSalesList({ ...params });
          toast.success(response.data.message);
          setStatusChange("");
          setModifyAcceptedModal(false);
        })
        .catch((err) => {
          toast.dismiss();
          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          setLoading(false);
          setDelModal(false);
        });
    }

    if (selectedRadio === "2") {
      let errorObj = { ...errorsObj };

      if (!failedData.reason_failed_sale) {
        errorObj.reason_failed_sale = "Reason is required.";
        setErrors(errorObj);
        Utils.focusError();
        setLoading(false);
        return;
      }

      const formData = new FormData();
      formData.append("id", statusChange.id);
      formData.append("order_status", 4);
      formData.append("reason_failed_sale", failedData.reason_failed_sale);

      selectedFiles.forEach((file) => {
        formData.append("images[]", file);
      });

      updateCompanySalesStatus(formData)
        .then((response) => {
          featchSalesList({ ...params });
          toast.success(response.data.message);
          setStatusChange("");
          setModifyAcceptedModal(false);
        })
        .catch((err) => {
          toast.dismiss();
          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          setLoading(false);
          setDelModal(false);
        });
    }
  };

  const handleAddCancelStatusSubmit = (e) => {
    e.preventDefault();
    setCancelLoading(true); // start loader

    let error = false;
    let errorObj = { ...errorsObj };

    if (!failedData.reason_failed_sale) {
      errorObj.reason_failed_sale = "Reason is required.";
      error = true;
    }

    setErrors(errorObj);
    Utils.focusError();

    if (error) {
      setCancelLoading(false); // stop loader on validation error
      return;
    }

    const formData = new FormData();
    formData.append("id", statusChange.id);
    formData.append("order_status", salesData?.order_status);
    formData.append("reason_failed_sale", failedData.reason_failed_sale);

    updateCompanySalesStatus(formData)
      .then((response) => {
        featchSalesList({ ...params });
        toast.success(response.data.message);
        setStatusChange("");
        setModifyCancelModal(false);
      })
      .catch((err) => {
        toast.dismiss();
        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        setCancelLoading(false); // always stop loader
        setDelModal(false);
      });

    setModifyCancelModal(true);
  };

  const handleAddRefundStatusSubmit = (e) => {
    e.preventDefault();
    setRefundLoading(true);

    let error = false;
    let errorObj = { ...errorsObj };

    if (refundData?.refund_type === 2) {
      if (!refundData.refund_value) {
        errorObj.refund_value = "Refund value is required.";
        error = true;
      }
    }

    if (!refundData.refund_type) {
      errorObj.refund_type = "Refund type is required.";
      error = true;
    }

    if (!refundData.refund_reason) {
      errorObj.refund_reason = "Reason is required.";
      error = true;
    }

    setErrorsRefund(errorObj);
    Utils.focusError();

    if (error) {
      setRefundLoading(false); // stop loader on validation error
      return;
    }

    const formData = new FormData();
    formData.append("id", statusChange.id);
    formData.append("order_status", 5);
    formData.append("refund_type", refundData.refund_type);
    formData.append("refund_reason", refundData.refund_reason);
    formData.append("refund_value", refundData.refund_value || 0);

    updateCompanySalesStatus(formData)
      .then((response) => {
        featchSalesList({ ...params });
        toast.success(response.data.message);
        setStatusChange("");
        setModifyRefundModal(false);
      })
      .catch((err) => {
        toast.dismiss();
        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        setRefundLoading(false); //  stop loader always
        setDelModal(false);
      });

    setModifyRefundModal(true);
  };

  useEffect(() => {
    if (statusChange) {
      setSalesData((prevSalesData) => ({
        ...prevSalesData, // Keep previous values
        order_status: statusChange?.order_status, // Update only order_status
      }));
    }
  }, [statusChange]);

  useEffect(() => {
    const currentPath = location.pathname;
    const savedPath = localStorage.getItem("lastVisitedPath");

    if (savedPath && savedPath !== currentPath) {
      localStorage.removeItem("lastVisitedPage");
      localStorage.removeItem("searchValue");
      localStorage.removeItem("orderStatus");

      localStorage.removeItem("marketPlaceId");
    }

    localStorage.setItem("lastVisitedPath", currentPath);

    const savedPage = localStorage.getItem("lastVisitedPage");
    const storedSearch = localStorage.getItem("searchValue") || "";
    const storedOrder = localStorage.getItem("orderStatus") || "";
    const storedMarket = localStorage.getItem("marketPlaceId") || "";
    const finalOrderStatus =
      state?.order_status !== undefined && state?.order_status !== null
        ? state.order_status
        : storedOrder;

    if (
      location.pathname === "/sales" &&
      state?.order_status !== undefined &&
      state?.order_status !== null
    ) {
      localStorage.setItem("orderStatus", state.order_status);
    }

    if (location.pathname !== "/sales") {
      localStorage.removeItem("orderStatus");
    }

    setParams((prevParams) => ({
      ...prevParams,
      search: storedSearch,
      page: savedPage ? parseInt(savedPage, 10) : 1,
      order_status: finalOrderStatus ? parseInt(finalOrderStatus) : "",
      market_place_id: storedMarket,
    }));
  }, [location.pathname, state]);

  const handleParams = (e, type) => {
    let paramsObj = { ...params };
    if (type === "length") {
      paramsObj.limit = e.target.value;
    } else if (type === "search") {
      paramsObj.page = 1;
      paramsObj.search = e.target.value;
      localStorage.setItem("searchValue", e.target.value); // Save search to localStorage
      localStorage.removeItem("lastVisitedPage");
    } else if (type === "pagination") {
      paramsObj.page = e.selected + 1; // ReactPaginate starts from 0, so we add 1
      localStorage.setItem("lastVisitedPage", e.selected + 1); // Save the selected page to localStorage
    } else if (type === "order_status") {
      const status = parseInt(e.target.value);
      paramsObj.order_status = status;
      localStorage.setItem("orderStatus", status);
    } else if (type === "market_place_id") {
      const marketId = parseInt(e.target.value);
      paramsObj.market_place_id = marketId;
      localStorage.setItem("marketPlaceId", marketId);
    }
    setParams(paramsObj);
  };

  const featchSalesList = () => {
    let data = { ...params };
    getCompanySalesList(data)
      .then((response) => {
        setSalesList(response.data.data);
        setTotalRecords(response.data.total);
      })
      .catch((err) => {
        toast.dismiss();
        toast.error(Utils.getErrorMessage(err));
      });
  };

  useEffect(
    function () {
      let data = { ...params };

      featchSalesList(data);
    },
    [params],
  );

  const onDeleteModalClose = () => {
    setDelModal(false);
  };

  const onDeleteModalOpen = (e, item) => {
    e.preventDefault();
    setStatusChange(item);
    setDelModal(true);
  };

  // const onDestroyPartType = (e) => {
  //   e.preventDefault();
  //   setIsDelButtonLoad(true);
  //   let data = { id: statusChange.id, order_status: salesData?.order_status };
  //   updateCompanySalesStatus(data)
  //     .then((response) => {
  //       let data = { ...params };

  //       featchSalesList(data);
  //       toast.success(response.data.message);
  //       setStatusChange("");
  //       setStatusModal(false);
  //       setIsDelButtonLoad(false);
  //     })
  //     .catch((err) => {
  //       setIsDelButtonLoad(false);
  //       toast.dismiss();
  //       toast.error(Utils.getErrorMessage(err));
  //     });
  // };

  const handleAddAccpetedStatusInternalSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    if (selectedRadioAccepted === "1") {
      const formData = new FormData();
      formData.append("internal_sales_id", statusChange.id);
      formData.append("sales_status", 3);
      selectedInternalFiles.forEach((file) => {
        formData.append("order_images", file);
      });
      formData.append("sales_type", 1);

      internalSalesFileUpdate(formData)
        .then((response) => {
          toast.success(response.data.message);
          setStatusChange("");
          setModifyAcceptedInternalModal(false);
          setFailedData({
            shipping_company: "",
            shipping_tracking_code: "",
            reason_failed_sale: "",
            add_file: "",
          });
          let data = { ...params };

          featchSalesList(data);
        })
        .catch((err) => {
          toast.dismiss();
          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          setLoading(false);
          setStatusChangeModal(false);
        });
    }

    if (selectedRadioAccepted === "2") {
      setLoading(true);

      let errorObj = {};
      let hasError = false;

      if (!syncFormData?.date) {
        errorObj.date = "Date is required.";
        hasError = true;
        setLoading(false);
      }

      if (!syncFormData?.document_set_id) {
        errorObj.document_set_id = "Document Set is required.";
        hasError = true;
        setLoading(false);
      }

      if (!syncFormData?.customer_id) {
        errorObj.customer_id = "Customer is required.";
        hasError = true;
        setLoading(false);
      }

      if (!syncFormData?.expiration_date) {
        errorObj.expiration_date = "Expiration Date is required.";
        hasError = true;
      } else if (syncFormData?.date) {
        const start = new Date(syncFormData.date);
        const end = new Date(syncFormData.expiration_date);

        if (end < start) {
          errorObj.expiration_date = "Expiration Date must be after Date.";
          hasError = true;
          setLoading(false);
        }
      }

      if (!syncFormData?.your_reference) {
        errorObj.your_reference = "Your Reference is required.";
        hasError = true;
        setLoading(false);
      }

      if (!syncFormData?.our_reference) {
        errorObj.our_reference = "Our Reference is required.";
        hasError = true;
        setLoading(false);
      }

      if (!syncFormData?.notes) {
        errorObj.notes = "Notes is required.";
        hasError = true;
        setLoading(false);
      }

      if (!syncFormData?.total_value_packaging) {
        errorObj.total_value_packaging = "Total value packaging is required.";
        hasError = true;
        setLoading(false);
      }

      if (!syncFormData?.total_value_other_parcel) {
        errorObj.total_value_other_parcel =
          "Total value other value is required.";
        hasError = true;
        setLoading(false);
      }

      if (!syncFormData?.total_value_shipping) {
        errorObj.total_value_shipping = "Total value shipping is required.";
        hasError = true;
        setLoading(false);
      }

      if (!syncFormData?.exemption_vat_products) {
        errorObj.exemption_vat_products = "Exemption vat products is required.";
        hasError = true;
        setLoading(false);
      }

      if (!syncFormData?.exemption_vat_shipping) {
        errorObj.exemption_vat_shipping = "Exemption vat shipping is required.";
        hasError = true;
        setLoading(false);
      }

      if (!syncFormData?.exemption_vat_packaging) {
        errorObj.exemption_vat_packaging =
          "Exemption vat packaging is required.";
        hasError = true;
        setLoading(false);
      }

      setErrors(errorObj);
      Utils.focusError();

      if (hasError) {
        setLoading(false);
        return;
      }

      let payload = {
        id: statusChange?.id,
        date: syncFormData?.date,
        expiration_date: syncFormData?.expiration_date,
        document_set_id: syncFormData?.document_set_id,
        customer_id: syncFormData?.customer_id,
        our_reference: syncFormData?.our_reference,
        your_reference: syncFormData?.your_reference,
        notes: syncFormData?.notes,
        total_value_packaging: syncFormData?.total_value_packaging,
        total_value_other_parcel: syncFormData?.total_value_other_parcel,
        total_value_shipping: syncFormData?.total_value_shipping,
        exemption_vat_products: syncFormData?.exemption_vat_products,
        exemption_vat_shipping: syncFormData?.exemption_vat_shipping,
        exemption_vat_packaging: syncFormData?.exemption_vat_packaging,
        sales_type: 1,
        button_type: 2,
      };

      createInpvoiceInternalSales(payload)
        .then((response) => {
          toast.success(response.data.message);
          setStatusChange("");
          setModifyAcceptedInternalModal(false);
          let data = { ...params };

          featchSalesList(data);
          setSyncFormData({
            price_value: "",
            selected_ids: [],
          });
          setLoading(false);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
          setLoading(false);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  return (
    <div>
      {isLoading ? (
        // <div className="text-center pageLoader">
        //   <div className="spinner-border" role="status">
        //     <span className="visually-hidden">Loading...</span>
        //   </div>
        // </div>
        <div className="skeleton-loader p-3 d-none">
          <div className="card">
            <div className="card-header">
              <table className="table rounded-table table-striped table-hover">
                <thead>
                  <tr>
                    <th
                      style={{ width: 10, borderTop: "0", borderBottom: "0" }}
                    >
                      <div className="skeleton"> </div>
                    </th>
                    <th style={{ borderTop: "0", borderBottom: "0" }}>
                      <div className="skeleton"></div>
                    </th>
                    <th style={{ borderTop: "0", borderBottom: "0" }}></th>
                    <th
                      className="d-flex"
                      style={{ borderTop: "0", borderBottom: "0" }}
                    >
                      <div className="skeleton me-1"></div>
                      <div className="skeleton me-1"></div>
                      <div className="skeleton"></div>
                    </th>
                    <th
                      style={{ width: 10, borderTop: "0", borderBottom: "0" }}
                    >
                      <div className="skeleton"></div>
                    </th>
                  </tr>
                </thead>
              </table>
            </div>
            <div className="card-body">
              <div className="vehicleThBg table-responsive">
                <table className="table table-bordered rounded-table table table-striped table-hover">
                  <thead>
                    <tr>
                      <th style={{ backgroundColor: "#c0c0c0" }}>
                        <div className="skeleton"></div>
                      </th>
                      <th style={{ backgroundColor: "#c0c0c0" }}>
                        <div className="skeleton"></div>
                      </th>
                      <th style={{ backgroundColor: "#c0c0c0" }}>
                        <div className="skeleton"></div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {salesList?.map((_, index) => (
                      <tr key={index}>
                        <td>
                          <div className="skeleton"></div>
                        </td>
                        <td>
                          <div className="skeleton"></div>
                        </td>
                        <td>
                          <div className="skeleton"></div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="card-footer">
              <div className="skeleton col-lg-3 float-right"></div>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  {/* <h1 className="page-title">Part Type</h1> */}
                </div>
                <div className="col-sm-6"></div>
              </div>
            </div>
            {/* /.container-fluid */}
          </section>
          <section className="content">
            <div className="container-fluid container-custom-height-new ">
              <div className="row">
                <div className="col-md-12">
                  <div className="card fuelCard">
                    <div className="card-header">
                      <div
                        className="card-title m-0 float-left"
                        style={{ width: "50%" }}
                      >
                        <div className="row">
                          <div className="col-md-4">
                            <input
                              type="text"
                              className="form-control"
                              value={params.search}
                              onChange={(e) => handleParams(e, "search")}
                              placeholder={t("search")}
                            ></input>
                          </div>

                          <div className="col-md-4">
                            <select
                              className="form-select"
                              type="select"
                              value={params.order_status || ""}
                              onChange={(e) => handleParams(e, "order_status")}
                            >
                              <option>All</option>
                              {orderStatusNameList?.map((item) => (
                                <option key={item.value} value={item.value}>
                                  {item.label}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="col-md-4">
                            <select
                              className="form-select"
                              type="select"
                              value={params.market_place_id}
                              onChange={(e) => {
                                handleParams(e, "market_place_id");
                              }}
                            >
                              <option>All</option>
                              {companyEcommerceList?.map((item) => (
                                <option key={item.id} value={item.id}>
                                  {item.ecommerce_name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="vehicleThBg table-responsive table-responsive-vehicle">
                        <table className="table table-bordered rounded-table table-striped table-hover">
                          <thead>
                            <tr>
                              <th
                                className="col-form-label ml-2 Label-my form-label form-label"
                                style={{ width: "10%" }}
                              >
                                Invoice Number{" "}
                              </th>

                              <th
                                className="col-form-label ml-2 Label-my form-label form-label"
                                style={{ width: "10%" }}
                              >
                                Quantity{" "}
                              </th>

                              <th
                                className="col-form-label ml-2 Label-my form-label form-label"
                                style={{ width: "10%" }}
                              >
                                Price{" "}
                              </th>

                              <th
                                className="col-form-label ml-2 Label-my form-label form-label"
                                style={{ width: "10%" }}
                              >
                                Created Date{" "}
                              </th>

                              <th
                                className="col-form-label ml-2 Label-my form-label form-label"
                                style={{ width: "10%" }}
                              >
                                Order Status Name{" "}
                              </th>

                              <th
                                className="col-form-label ml-2 Label-my form-label form-label"
                                style={{ textAlign: "center", width: "0%" }}
                              >
                                {t("action")}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {salesList?.map((item, index) => (
                              <tr key={item.id}>
                                {" "}
                                <td>{item?.invoice_number}</td>
                                <td>{item?.num_products}</td>
                                <td>{item?.total_value_products} €</td>
                                <td>
                                  {item?.created_at
                                    ? moment(item?.created_at).format(
                                        "DD/MM/YYYY",
                                      )
                                    : "-"}
                                </td>
                                <td>
                                  <span
                                    style={{
                                      backgroundColor:
                                        statusColorMap[
                                          String(item?.order_status)
                                        ],
                                      color: "white",
                                      padding: "4px 3px",
                                      borderRadius: "12px",
                                      fontSize: "12px",
                                      fontWeight: "600",
                                    }}
                                  >
                                    {tConstStatic(item?.order_status_name)}
                                  </span>
                                </td>
                                <td>
                                  <div className="d-flex">
                                    <Dropdown
                                      className="iconDropdown"
                                      onToggle={(isOpen) => {
                                        if (isOpen) {
                                          const tableResponsive =
                                            document.querySelector(
                                              ".table-responsive",
                                            );
                                          if (window.innerWidth <= 767) {
                                            if (tableResponsive) {
                                              tableResponsive.style.overflowX =
                                                "auto !important";
                                              tableResponsive.style.overflowY =
                                                "auto !important";
                                            }
                                          } else {
                                            if (tableResponsive) {
                                              tableResponsive.style.overflowX =
                                                "inherit !important";
                                              tableResponsive.style.overflowY =
                                                "inherit !important";
                                            }
                                          }
                                        }
                                      }}
                                    >
                                      <Dropdown.Toggle
                                        variant="success"
                                        id="dropdown-basic"
                                        className="iconToggle"
                                      >
                                        <i className="bi bi-three-dots-vertical"></i>
                                      </Dropdown.Toggle>

                                      <Dropdown.Menu>
                                        <Dropdown.Item
                                          href="#/action-1"
                                          className="d-flex"
                                          onClick={() =>
                                            navigate(
                                              `/sales-details/${item.id}`,
                                              { state: item },
                                            )
                                          }
                                        >
                                          <a className="" href="#"></a>
                                          <div className="edit-btn">
                                            <i className="bi bi-eye"></i>{" "}
                                          </div>
                                          <span>Details</span>
                                        </Dropdown.Item>
                                        {/* {item?.order_status == 1 && ( */}
                                        <Dropdown.Item
                                          href="#/action-2"
                                          className="d-flex"
                                          onClick={(e) =>
                                            onDeleteModalOpen(e, item)
                                          }
                                        >
                                          <a className="" href="#"></a>

                                          <div className="edit-btn">
                                            <i className="bi bi-arrow-repeat"></i>
                                          </div>
                                          <span>Status Change</span>
                                        </Dropdown.Item>
                                        {/* )} */}
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  </div>
                                </td>
                              </tr>
                            ))}
                            {salesList && salesList.length === 0 && (
                              <tr>
                                <td colSpan={4} className="text-center">
                                  Record Not Found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    {/* /.card-body */}
                  </div>
                </div>
              </div>
            </div>
            <div className="card-footer card-footer-part clearfix">
              <div className="pagination pagination-sm m-0 float-right">
                <ReactPaginate
                  previousLabel={<i className="bi bi-chevron-double-left"></i>}
                  nextLabel={<i className="bi bi-chevron-double-right"></i>}
                  breakLabel={"..."}
                  pageCount={Math.ceil(totalRecords / params.limit)}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={(e) => handleParams(e, "pagination")}
                  forcePage={params.page - 1}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                />
              </div>
            </div>
          </section>
        </div>
      )}
      <Modal isOpen={delModal} size="lg">
        <ModalHeader>{`Status Change`}</ModalHeader>
        <ModalBody>
          <div className="col-md-12">
            <FormGroup>
              <Label className="col-form-label ml-2 Label-my form-label form-label">
                {"Order Status"}
              </Label>
              <div className="col-xl-12">
                <div className="input-div SelectV">
                  <Select
                    className="my-Select"
                    options={orderStatusNameList}
                    value={orderStatusNameList.find(
                      (item) => item.value === salesData.order_status,
                    )}
                    onChange={handleSelectChange}
                    placeholder={"Select Order Status"}
                    isSearchable={true}
                    isClearable={true}
                  />
                </div>
              </div>
            </FormGroup>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            disabled={isDelButtonLoad}
            onClick={onDeleteModalClose}
            style={{ width: "100px", marginTop: "10px" }}
          >{t("close")}<i className="bi bi-x-lg"></i>
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modifyModal}>
        <ModalHeader>Sales Details</ModalHeader>

        <ModalBody>
          <div className="row">
            <div className="col-md-6">
              <h6>Product Name : {salesViewData?.product_name}</h6>
            </div>
            <div className="col-md-6">
              <h6>Quantity : {salesViewData?.quantity}</h6>
            </div>
            <div className="col-md-6">
              <h6>Order Status Name : {tConstStatic(salesViewData?.order_status_name)}</h6>
            </div>
            <div className="col-md-6">
              <h6>price : {salesViewData?.price}</h6>
            </div>
            <div className="col-md-6">
              <h6>Customer Name : {salesViewData?.end_customer_name}</h6>
            </div>
            <div className="col-md-6">
              <h6>Customer Phone : {salesViewData?.end_customer_phone}</h6>
            </div>
            <div className="col-md-12">
              <h6>Customer Email : {salesViewData?.end_customer_email}</h6>
            </div>{" "}
          </div>
        </ModalBody>

        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleCloseModal}
            style={{ width: "100px", marginTop: "10px" }}
          >{t("close")}<i className="bi bi-x-lg"></i>
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modifyAcceptedModal} size="lg">
        {/* <ModalHeader>{`Status Change`}</ModalHeader> */}
        <ModalBody>
          <div className="card-body">
            <div className="row">
              <div className="col-md-6">
                <input
                  className="form-check-input"
                  type="radio"
                  name="flexRadio"
                  id="flexRadio1"
                  value="1"
                  checked={selectedRadio === "1"}
                  onChange={handleRadioChange}
                />
                <label className="form-check-label" htmlFor="flexRadio1">
                  Add Shipping Details
                </label>
              </div>

              <div className="col-md-6">
                <input
                  className="form-check-input"
                  type="radio"
                  name="flexRadio"
                  id="flexRadio2"
                  value="2"
                  checked={selectedRadio === "2"}
                  onChange={handleRadioChange}
                />
                <label className="form-check-label" htmlFor="flexRadio2">
                  Cancelled
                </label>
              </div>

              {selectedRadio === "1" && (
                <>
                  {statusChange?.seller_takes_care_shipping === true ? (
                    <>
                      <div className="col-md-12" style={{ marginTop: "12px" }}>
                        <div className="p-4 border rounded-lg">
                          <input
                            type="file"
                            accept="application/pdf"
                            onChange={handleFileChange}
                            className="border p-2 rounded-md"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <FormGroup>
                          <Label className="col-form-label ml-2 Label-my">
                            {"Shipping Company"}
                          </Label>
                          <div className="col-xl-12">
                            <div className="input-div">
                              <input
                                className="form-control input-search"
                                type="text"
                                value={failedData.shipping_company}
                                onChange={(e) => {
                                  setFailedData({
                                    ...failedData,
                                    shipping_company: e.target.value,
                                  });
                                }}
                                name={`shipping_company`}
                                maxLength={50}
                                placeholder={t("shipping_company")}
                              />
                            </div>
                          </div>
                        </FormGroup>
                      </div>

                      <div className="col-md-6">
                        <FormGroup>
                          <Label className="col-form-label ml-2 Label-my">
                            {"Shipping tracking code"}
                          </Label>
                          <div className="col-xl-12">
                            <div className="input-div">
                              <input
                                className="form-control input-search"
                                type="text"
                                value={failedData.shipping_tracking_code}
                                onChange={(e) => {
                                  setFailedData({
                                    ...failedData,
                                    shipping_tracking_code: e.target.value,
                                  });
                                }}
                                name={`shipping_tracking_code`}
                                maxLength={50}
                                placeholder={t("shipping_tracking_code")}
                              />
                            </div>
                          </div>
                        </FormGroup>
                      </div>
                      <div className="col-md-12">
                        <div className="p-4 border rounded-lg">
                          <input
                            type="file"
                            accept="image/*"
                            multiple
                            onChange={handleFileChangeImage}
                            className="border p-2 rounded-md"
                          />

                          {selectedFiles.length > 0 && (
                            <div className="mt-4 grid grid-cols-3 gap-2">
                              {selectedFiles.map((file, index) => (
                                <div key={index} className="relative">
                                  <img
                                    src={URL.createObjectURL(file)}
                                    alt={`preview-${index}`}
                                    style={{ width: "100px" }}
                                    className="object-cover rounded-lg shadow-md"
                                  />
                                  <button
                                    onClick={() => removeImage(index)}
                                    className="absolute top-0 right-0 bg-red-500 text-white text-xs p-1 rounded-full"
                                  >
                                    ✖
                                  </button>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="col-md-12" style={{ marginTop: "10px" }}>
                        <a
                          href={statusChange.shipping_label}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="bi bi-file-earmark-pdf"></i> View PDF
                        </a>
                      </div>

                      <div className="col-md-12" style={{ marginTop: "10px" }}>
                        <div className="p-4 border rounded-lg">
                          <input
                            type="file"
                            accept="image/*"
                            multiple
                            onChange={handleFileChangeImage}
                            className="border p-2 rounded-md"
                          />

                          {selectedFiles.length > 0 && (
                            <div className="mt-4 grid grid-cols-3 gap-2">
                              {selectedFiles.map((file, index) => (
                                <div key={index} className="relative">
                                  <img
                                    src={URL.createObjectURL(file)}
                                    alt={`preview-${index}`}
                                    style={{ width: "100px" }}
                                    className="object-cover rounded-lg shadow-md"
                                  />
                                  <button
                                    onClick={() => removeImage(index)}
                                    className="absolute top-0 right-0 bg-red-500 text-white text-xs p-1 rounded-full"
                                  >
                                    ✖
                                  </button>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}

              {selectedRadio === "2" && (
                <>
                  <div className="col-md-12">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my">
                        {"Reason Failed Sale"}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <textarea
                            className="form-control input-search"
                            type="text"
                            value={failedData.reason_failed_sale}
                            onChange={(e) => {
                              setFailedData({
                                ...failedData,
                                reason_failed_sale: e.target.value,
                              });
                            }}
                            name={`reason_failed_sale`}
                            placeholder={t("reason_failed_sale")}
                            rows={3}
                          />
                          {errors.reason_failed_sale && (
                            <span className="input-error">
                              {errors.reason_failed_sale}
                            </span>
                          )}
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-12">
                    <div className="p-4 border rounded-lg">
                      <input
                        type="file"
                        accept="image/*"
                        multiple
                        onChange={handleFileChangeImage}
                        className="border p-2 rounded-md"
                      />

                      {selectedFiles.length > 0 && (
                        <div className="mt-4 grid grid-cols-3 gap-2">
                          {selectedFiles.map((file, index) => (
                            <div key={index} className="relative">
                              <img
                                src={URL.createObjectURL(file)}
                                alt={`preview-${index}`}
                                style={{ width: "100px" }}
                                className="object-cover rounded-lg shadow-md"
                              />
                              <button
                                onClick={() => removeImage(index)}
                                className="absolute top-0 right-0 bg-red-500 text-white text-xs p-1 rounded-full"
                              >
                                ✖
                              </button>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleAcceptedClose}
            style={{ width: "100px", marginTop: "10px" }}
          >{t("close")}<i className="bi bi-x-lg"></i>
          </button>

          <button
            type="button"
            className="btn btn-block btn-primary"
            style={{ width: "139px" }}
            onClick={handleAddAccpetedStatusSubmit}
            disabled={loading}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Saving...
              </>
            ) : (
              <>{t("save")}<i className="bi bi-arrow-repeat"></i>
              </>
            )}
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modifyCancelModal} size="lg">
        {/* <ModalHeader>{`Status Change`}</ModalHeader> */}
        <ModalBody>
          <div className="card-body">
            <div className="row">
              <div className="col-md-12">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {"Reason"}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <textarea
                        className="form-control input-search"
                        type="text"
                        value={failedData.reason_failed_sale}
                        onChange={(e) => {
                          setFailedData({
                            ...failedData,
                            reason_failed_sale: e.target.value,
                          });
                        }}
                        name={`reason_failed_sale`}
                        rows={3}
                        placeholder={t("reason")}
                      />
                      {errors.reason_failed_sale && (
                        <span className="input-error">
                          {errors.reason_failed_sale}
                        </span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleCancelClose}
            style={{ width: "100px", marginTop: "10px" }}
          >{t("close")}<i className="bi bi-x-lg"></i>
          </button>

          <button
            type="button"
            className="btn btn-block btn-primary"
            style={{ width: "139px" }}
            onClick={handleAddCancelStatusSubmit}
            disabled={cancelLoading}
          >
            {cancelLoading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                />
                Saving...
              </>
            ) : (
              <>{t("save")}<i className="bi bi-arrow-repeat"></i>
              </>
            )}
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modifyRefundModal} size="lg">
        <ModalBody>
          <div className="card-body">
            <div className="row">
              <div className="col-md-12">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                    {"Refund Type"}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div SelectV">
                      <Select
                        className="my-Select"
                        options={refundTypeList}
                        value={refundTypeList.find(
                          (item) => item.value == refundData.refund_type,
                        )}
                        onChange={handleSelectChangeRefund}
                        placeholder={"Select Refund Type"}
                        isSearchable={true}
                        isClearable={true}
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>
              <div className="col-md-6">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {"Reason"}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={refundData.refund_reason}
                        onChange={(e) => {
                          setRefundData({
                            ...refundData,
                            refund_reason: e.target.value,
                          });
                        }}
                        name={`refund_reason`}
                        maxLength={50}
                        placeholder={t("reason")}
                      />
                      {errorsRefund.refund_reason && (
                        <span className="input-error">
                          {errorsRefund.refund_reason}
                        </span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>
              {refundData?.refund_type === 2 ? (
                <div className="col-md-6">
                  <FormGroup>
                    <Label className="col-form-label ml-2 Label-my">
                      {"Refund Value"}
                    </Label>
                    <div className="col-xl-12">
                      <div className="input-div">
                        <input
                          className="form-control input-search"
                          type="text"
                          value={refundData.refund_value}
                          onChange={(e) => {
                            setRefundData({
                              ...refundData,
                              refund_value: e.target.value,
                            });
                          }}
                          name={`refund_value`}
                          maxLength={50}
                          placeholder={t("refund_value")}
                        />
                        {errorsRefund.refund_value && (
                          <span className="input-error">
                            {errorsRefund.refund_value}
                          </span>
                        )}
                      </div>
                    </div>
                  </FormGroup>
                </div>
              ) : (
                <div className="col-md-6"></div>
              )}
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleRefundClose}
            style={{ width: "100px", marginTop: "10px" }}
          >{t("close")}<i className="bi bi-x-lg"></i>
          </button>

          <button
            type="button"
            className="btn btn-block btn-primary"
            style={{ width: "139px" }}
            onClick={handleAddRefundStatusSubmit}
            disabled={refundLoading}
          >
            {refundLoading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                />
                Saving...
              </>
            ) : (
              <>{t("save")}<i className="bi bi-arrow-repeat"></i>
              </>
            )}
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modifyAcceptedInternalModal} size="xl">
        {/* <ModalHeader>{`Status Change`}</ModalHeader> */}
        <ModalBody>
          <div className="card-body">
            <div className="row">
              <div
                className="row"
                style={{ padding: "14px", marginBottom: "15px" }}
              >
                <div className="col-md-6">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="flexRadio"
                    id="flexRadio1"
                    value="1"
                    checked={selectedRadioAccepted === "1"}
                    onChange={handleRadioInternalSaleChange}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexRadio1"
                    style={{ fontSize: "15px", fontWeight: "bolder" }}
                  >
                    Upload Pdf
                  </label>
                </div>

                <div className="col-md-6">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="flexRadio"
                    id="flexRadio2"
                    value="2"
                    checked={selectedRadioAccepted === "2"}
                    onChange={handleRadioInternalSaleChange}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexRadio2"
                    style={{ fontSize: "15px", fontWeight: "bolder" }}
                  >
                    Create Invoice
                  </label>
                </div>
              </div>

              {selectedRadioAccepted === "1" && (
                <>
                  {/* <div className="col-md-12" style={{ marginTop: "10px" }}>
                          <a
                            href={statusChange.shipping_label}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="bi bi-file-earmark-pdf"></i> View PDF
                          </a>
                        </div> */}

                  <div className="col-md-12" style={{ marginTop: "10px" }}>
                    <div className="p-4 border rounded-lg">
                      <input
                        ref={fileInputRef}
                        type="file"
                        accept=".pdf,.csv,.xls,.xlsx,.jpg,.jpeg,.png"
                        onChange={handleFileChangeImageInternal}
                        className="border p-2 rounded-md"
                      />

                      <div className="grid grid-cols-1 gap-2 mt-3">
                        {/* Image Preview */}
                        {imagePreview && (
                          <div className="mt-2">
                            <img
                              src={imagePreview}
                              alt="Preview"
                              style={{
                                maxWidth: "200px",
                                maxHeight: "200px",
                                borderRadius: "6px",
                                border: "1px solid #ddd",
                              }}
                            />
                            <button
                              onClick={removeFile}
                              className="bg-red-500 text-white text-xs px-2 py-1 rounded ms-3"
                              style={{ background: "red" }}
                              disabled={imageLoader}
                            >
                              {imageLoader ? (
                                <>
                                  <span
                                    className="spinner-border spinner-border-sm me-2"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                  Removing...
                                </>
                              ) : (
                                "Remove"
                              )}
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              )}

              {selectedRadioAccepted === "2" && (
                <>
                  <div className="col-md-4">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("date")}
                        <span className="text-danger ms-1 fw-bold">*</span>
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <input
                            className="form-control input-search"
                            type="date"
                            value={syncFormData.date}
                            onChange={(e) => {
                              setSyncFormData({
                                ...syncFormData,
                                date: e.target.value,
                              });
                            }}
                            name="date"
                            placeholder={t("expiration_date")}
                          />
                        </div>
                        {errors.date && (
                          <span className="input-error">{errors.date}</span>
                        )}
                      </div>
                    </FormGroup>
                  </div>
                  <div className="col-md-4">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("expirationDate")}
                        <span className="text-danger ms-1 fw-bold">*</span>
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <input
                            className="form-control input-search"
                            type="date"
                            value={syncFormData.expiration_date}
                            onChange={(e) => {
                              setSyncFormData({
                                ...syncFormData,
                                expiration_date: e.target.value,
                              });
                            }}
                            name="expiration_date"
                            placeholder={t("expiration_date")}
                          />
                        </div>
                        {errors.expiration_date && (
                          <span className="input-error">
                            {errors.expiration_date}
                          </span>
                        )}
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-4">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("documentSet")}
                        <span className="text-danger ms-1 fw-bold">*</span>
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <Select
                            className="my-select-v"
                            options={documentSetList}
                            value={documentSetList.find(
                              (item) =>
                                item.value === syncFormData.document_set_id,
                            )}
                            onChange={(selectedOption) => {
                              setSyncFormData({
                                ...syncFormData,
                                document_set_id: selectedOption
                                  ? selectedOption.value
                                  : "",
                              });
                            }}
                            isSearchable={true}
                            isClearable={true}
                            placeholder={"Select Document Set"}
                          />
                          {errors.document_set_id && (
                            <span className="input-error">
                              {errors.document_set_id}
                            </span>
                          )}
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-4">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("customer")}
                        <span className="text-danger ms-1 fw-bold">*</span>
                        <i
                          className="bi bi-info-circle-fill"
                          style={{
                            marginLeft: "215px",
                            color: "blue",
                            fontSize: "20px",
                            cursor: "pointer",
                          }}
                          onClick={handleCustomerModelOpen}
                        ></i>
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <Select
                            className="my-select-v"
                            options={customerList}
                            value={customerList.find(
                              (item) => item.value === syncFormData.customer_id,
                            )}
                            onChange={(selectedOption) => {
                              setSyncFormData({
                                ...syncFormData,
                                customer_id: selectedOption
                                  ? selectedOption.value
                                  : "",
                              });
                            }}
                            isSearchable={true}
                            isClearable={true}
                            placeholder={"Select Customer"}
                          />
                          {errors.customer_id && (
                            <span className="input-error">
                              {errors.customer_id}
                            </span>
                          )}
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-4">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("our_reference")}
                        <span className="text-danger ms-1 fw-bold">*</span>
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <input
                            className="form-control input-search"
                            type="text"
                            value={syncFormData.our_reference}
                            onChange={(e) => {
                              setSyncFormData({
                                ...syncFormData,
                                our_reference: e.target.value,
                              });
                            }}
                            name="our_reference"
                            placeholder={t("our_reference")}
                          />
                        </div>
                        {errors.our_reference && (
                          <span className="input-error">
                            {errors.our_reference}
                          </span>
                        )}
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-4">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("your_reference")}
                        <span className="text-danger ms-1 fw-bold">*</span>
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <input
                            className="form-control input-search"
                            type="text"
                            value={syncFormData.your_reference}
                            onChange={(e) => {
                              setSyncFormData({
                                ...syncFormData,
                                your_reference: e.target.value,
                              });
                            }}
                            name="your_reference"
                            placeholder={t("your_reference")}
                          />
                        </div>
                        {errors.your_reference && (
                          <span className="input-error">
                            {errors.your_reference}
                          </span>
                        )}
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-4">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("notes")}
                        <span className="text-danger ms-1 fw-bold">*</span>
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <input
                            className="form-control input-search"
                            type="text"
                            value={syncFormData.notes}
                            onChange={(e) => {
                              setSyncFormData({
                                ...syncFormData,
                                notes: e.target.value,
                              });
                            }}
                            name="notes"
                            placeholder={t("notes")}
                          />
                        </div>
                        {errors.notes && (
                          <span className="input-error">{errors.notes}</span>
                        )}
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-4">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("total_value_packaging")}
                        <span className="text-danger ms-1 fw-bold">*</span>
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <input
                            className="form-control input-search"
                            type="text"
                            value={syncFormData.total_value_packaging}
                            onChange={(e) => {
                              setSyncFormData({
                                ...syncFormData,
                                total_value_packaging: e.target.value,
                              });
                            }}
                            name="total_value_packaging"
                            placeholder={t("total_value_packaging")}
                          />
                          {errors.total_value_packaging && (
                            <span className="input-error">
                              {errors.total_value_packaging}
                            </span>
                          )}
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-4">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("total_value_other_parcel")}
                        <span className="text-danger ms-1 fw-bold">*</span>
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <input
                            className="form-control input-search"
                            type="text"
                            value={syncFormData.total_value_other_parcel}
                            onChange={(e) => {
                              setSyncFormData({
                                ...syncFormData,
                                total_value_other_parcel: e.target.value,
                              });
                            }}
                            name="total_value_other_parcel"
                            placeholder={t("total_value_other_parcel")}
                          />
                          {errors.total_value_other_parcel && (
                            <span className="input-error">
                              {errors.total_value_other_parcel}
                            </span>
                          )}
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-4">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("total_value_shipping")}
                        <span className="text-danger ms-1 fw-bold">*</span>
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <input
                            className="form-control input-search"
                            type="text"
                            value={syncFormData.total_value_shipping}
                            onChange={(e) => {
                              setSyncFormData({
                                ...syncFormData,
                                total_value_shipping: e.target.value,
                              });
                            }}
                            name="total_value_shipping"
                            placeholder={t("total_value_shipping")}
                          />
                          {errors.total_value_shipping && (
                            <span className="input-error">
                              {errors.total_value_shipping}
                            </span>
                          )}
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-4">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {"Exemption Vat Other Parcel"}
                        <span className="text-danger ms-1 fw-bold">*</span>
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div ">
                          <Select
                            options={exemptionList}
                            value={
                              exemptionList.find(
                                (option) =>
                                  option.value ===
                                  syncFormData.exemption_vat_products,
                              ) || null
                            }
                            onChange={(selectedOption) =>
                              setSyncFormData({
                                ...syncFormData,
                                exemption_vat_products: selectedOption
                                  ? selectedOption.value
                                  : "",
                              })
                            }
                            placeholder={"Select Exemption Vat Other Parcel"}
                            isClearable
                            isSearchable
                          />
                          {errors.exemption_vat_products && (
                            <span className="input-error">
                              {errors.exemption_vat_products}
                            </span>
                          )}
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-4">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label">
                        {"Exemption Vat Shipping"}
                        <span className="text-danger ms-1 fw-bold">*</span>
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <Select
                            options={exemptionList}
                            value={
                              exemptionList.find(
                                (option) =>
                                  option.value ===
                                  syncFormData.exemption_vat_shipping,
                              ) || null
                            }
                            onChange={(selectedOption) =>
                              setSyncFormData({
                                ...syncFormData,
                                exemption_vat_shipping: selectedOption
                                  ? selectedOption.value
                                  : "",
                              })
                            }
                            placeholder={"Select Exemption Vat Shipping"}
                            isClearable
                            isSearchable
                          />
                          {errors.exemption_vat_shipping && (
                            <span className="input-error">
                              {errors.exemption_vat_shipping}
                            </span>
                          )}
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-4">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label">
                        {"Exemption Vat Packaging"}
                        <span className="text-danger ms-1 fw-bold">*</span>
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <Select
                            options={exemptionList}
                            value={exemptionList.find(
                              (option) =>
                                option.value ===
                                syncFormData.exemption_vat_packaging,
                            )}
                            onChange={(selectedOption) =>
                              setSyncFormData({
                                ...syncFormData,
                                exemption_vat_packaging: selectedOption
                                  ? selectedOption.value
                                  : "",
                              })
                            }
                            placeholder={"Select Exemption Vat Packaging"}
                            isClearable
                            isSearchable
                          />
                          {errors.exemption_vat_packaging && (
                            <span className="input-error">
                              {errors.exemption_vat_packaging}
                            </span>
                          )}
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-4"></div>
                  <div className="col-md-4"></div>

                  <div className="row">
                    <div className="col-md-12">
                      <div className="Label-my mb-2 mt-2">Part Details</div>
                      <div
                        className="vehicleThBg table-responsive tableScroll table-scroll-modal"
                        style={{
                          height: "150px",
                          minHeight: "150px",
                        }}
                      >
                        <table className="rounded-table table table-striped table-bordered table-hover">
                          <thead>
                            <tr>
                              <th>Part Name</th>
                              <th>Warehouse name</th>
                              <th>Sales Price</th>
                              <th>Sales VAT Price</th>
                              <th>Sales Order Notes</th>
                            </tr>
                          </thead>

                          <tbody>
                            {statusChange?.part_list?.length > 0 ? (
                              statusChange?.part_list?.map((item, index) => (
                                <tr key={index}>
                                  <td>{item?.namePartPT}</td>
                                  <td>{item?.warehouse_name}</td>
                                  <td>{item?.internal_sales_price}</td>
                                  <td>{item?.internal_sales_vat_price}</td>
                                  <td>{item?.internal_sales_order_notes}</td>
                                </tr>
                              ))
                            ) : (
                              <tr className="scrollBrdr">
                                <td colSpan="100%">No results found</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleAcceptedInternalClose}
            style={{ width: "100px", marginTop: "10px" }}
          >{t("close")}<i className="bi bi-x-lg"></i>
          </button>

          <button
            type="button"
            className="btn btn-block btn-primary"
            style={{ width: "139px" }}
            onClick={handleAddAccpetedStatusInternalSubmit}
            disabled={loading}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Saving...
              </>
            ) : (
              <>{t("save")}<i className="bi bi-arrow-repeat"></i>
              </>
            )}
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={customerModel}>
        <ModalHeader>Details</ModalHeader>

        <ModalBody>
          {customerAllList?.map((item) => {
            return (
              <>
                {item?.seller_invoice_provider === true && (
                  <div className="row">
                    <div>
                      {item?.provider_list?.map((items) => {
                        return (
                          <>
                            <div className="col-md-12">
                              <h6>Product Name : {items?.name}</h6>
                            </div>
                            <div className="col-md-12">
                              <h6>Phone : {items?.phone}</h6>
                            </div>
                            <div className="col-md-12">
                              <h6>Email : {items?.email}</h6>
                            </div>
                            <div className="col-md-12">
                              <h6>Whatsapp : {items?.whatsapp}</h6>
                            </div>
                            <div className="col-md-12">
                              <h6>VAT Number : {items?.vat_number}</h6>
                            </div>
                            <div className="col-md-12">
                              <h6>
                                Shipping Address : {items?.shipping_address}
                              </h6>
                            </div>
                            <div className="col-md-12">
                              <h6>Postal Code : {items?.postal_code}</h6>
                            </div>{" "}
                            <div className="col-md-12">
                              <h6>
                                Country Code VAT Number :{" "}
                                {items?.country_code_vat_number}
                              </h6>
                            </div>{" "}
                            <div className="col-md-12">
                              <h6>Country Code : {items?.country_code}</h6>
                            </div>{" "}
                            <div className="col-md-12">
                              <h6>City : {items?.city}</h6>
                            </div>{" "}
                          </>
                        );
                      })}
                    </div>
                  </div>
                )}

                {item?.seller_invoice_client === true && (
                  <div className="row">
                    <div>
                      {item?.client_list?.map((items) => {
                        return (
                          <>
                            <div className="col-md-12">
                              <h6> Name : {items?.name}</h6>
                            </div>
                            <div className="col-md-12">
                              <h6>Phone : {items?.phone_number}</h6>
                            </div>
                            <div className="col-md-12">
                              <h6>Email : {items?.email}</h6>
                            </div>
                            <div className="col-md-12">
                              <h6>Whatsapp : {items?.whatsapp_number}</h6>
                            </div>
                            <div className="col-md-12">
                              <h6>VAT Number : {items?.vat_number}</h6>
                            </div>
                            <div className="col-md-12">
                              <h6>
                                Shipping Address :{" "}
                                {items?.shipping_address?.map((item, index) => (
                                  <p key={index}>{item}</p>
                                ))}{" "}
                              </h6>
                            </div>
                            <div className="col-md-12">
                              <h6>Postal Code : {items?.postal_code}</h6>
                            </div>{" "}
                            <div className="col-md-12">
                              <h6>
                                Country Code VAT Number :{" "}
                                {items?.vat_country_code}
                              </h6>
                            </div>{" "}
                            <div className="col-md-12">
                              <h6>Country Code : {items?.country_code}</h6>
                            </div>{" "}
                            <div className="col-md-12">
                              <h6>City : {items?.city}</h6>
                            </div>{" "}
                          </>
                        );
                      })}
                    </div>
                  </div>
                )}
              </>
            );
          })}
        </ModalBody>

        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleCustomerModelClose}
            style={{ width: "100px", marginTop: "10px" }}
          >{t("close")}<i className="bi bi-x-lg"></i>
          </button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default Sales;
